module.exports = __webpack_public_path__ + "img/mocknodata.c5978229.svg";